<template>
  <div class="container">
    <h1>
       <b-icon icon="file-earmark-text"></b-icon> Select Subject

       <div class="float-right" style="margin-top: -62px">
        <b-button
          v-b-modal.modal-help
          v-b-tooltip.hover
          title="Help"
          class="help"
        >
          <b-icon icon="question-square-fill"></b-icon> Help</b-button
        >


      <Help id="11"/>

      </div>

      <div class="float-right">
        <b-button v-b-modal.modal-lg v-b-tooltip.hover title="Filter">
          <b-icon icon="filter"></b-icon> Filter</b-button
        >
        <b-button v-b-tooltip.hover title="Auto FIlter" class="m-1" @click="StudentCustomRegistrationCourses">
          <b-icon icon="filter"></b-icon> Auto Filter</b-button
        >
        <b-button class="btn btn-info" @click="getAllStudentRegistrationCourses" v-b-tooltip.hover title="clear filter">
          <b-icon icon="x-circle"></b-icon> Clear Filter</b-button
        >
        <!-- 
  <b-modal id="modal-lg" size="lg" title="Filter">
   
  <div class="panal2">
    <div>
      
      <div class="panal-header2"> </div>
     <div class="panal-body2">

  <div >

   <b-form-group label="">
      <b-form-radio-group id="radio-group-2"  name="radio-sub-component">
        <b-form-radio value="first">All Courses</b-form-radio>
        <b-form-radio value="second">Registered Courses</b-form-radio>
        <b-form-radio value="third">Not registered courses</b-form-radio>
        <b-form-radio value="fourth">On Cart courses</b-form-radio>
      </b-form-radio-group>
    </b-form-group>



  </div>
  <hr/>
  <div>
  <h6> Levels </h6>
<span class="col-md-4">Student level</span>
<b-form-select v-model="selected" :options="options" class="col-md-9"></b-form-select>
    <div class="mt-3 col-md-4">Selected: <strong>{{ selected }}</strong></div>

</div>

<hr/>
  <div>
  <h6>Specialization </h6>
<span class="col-md-2">Student Specialization</span>
 <b-form-select v-model="selected2" class="mb-3 col-md-8">
      <b-form-select-option :value="null">Please select an option</b-form-select-option>
      <b-form-select-option value="a">Option A</b-form-select-option>
      <b-form-select-option value="b">Option B </b-form-select-option>
      <b-form-select-option value="b">Option C </b-form-select-option>
    </b-form-select>

    <div class="mt-2 col-md-2">Selected: <strong>{{ selected2 }}</strong></div>

</div>

<hr/>
  <div>
  <h6>Courses </h6>
  <b-row>
 <b-col class="col-md-2 mt-1">Course Code</b-col>
  <b-form-input v-model="text" class="col-md-3" placeholder="Enter course code"></b-form-input>
  <b-col class="col-md-2 mt-1">Course Name</b-col>
  <b-form-input v-model="text" class="col-md-4" placeholder="Enter course Name"></b-form-input>
  </b-row>
   

</div>



      </div>
     </div>

  

  </div>


  </b-modal>
-->

        <!-- Start Filter -->
        <b-modal id="modal-lg" size="md" title="Filter" hide-footer>
          <div class="panal2">
            <div>
              <!-- <div class="panal-header2"></div> -->
              <div class="panal-body2" id="Courses">
                <div class="filter">
                  <!-- <b-form-group label="">
                    <b-form-radio-group
                      id="radio-group-2"
                      name="radio-sub-component"
                    >
                      <b-form-radio value="All" v-model="FilterCourses"
                        >All Courses</b-form-radio
                      >

                      <b-form-radio value="Selected" v-model="FilterCourses"
                        >Selected courses</b-form-radio
                      >
                    </b-form-radio-group>
                  </b-form-group> -->

                   <!-- <b-form-group label="">
                  <b-form-radio-group id="radio-group-2"  name="radio-sub-component">
                    <b-form-radio value="All" v-model="FilterCourses" >All Courses</b-form-radio>
                    <b-form-radio value="RegisteredCourses" v-model="FilterCourses">Registered Courses</b-form-radio>
                    <b-form-radio value="NotRegisteredCourses" v-model="FilterCourses" >Not registered courses</b-form-radio>
                    <b-form-radio value="OnCartCourses" v-model="FilterCourses" >On Cart courses</b-form-radio>
                  </b-form-radio-group>
                </b-form-group> -->

                </div>
                <!-- <hr /> -->
                <div>
                  <h6>Levels</h6>
                  <span class="col-md-4">Student level</span>
                  <b-form-select v-model="LevelNameinsert" class="col-md-9" v-b-tooltip.hover title="Student level">
                    <b-form-select-option
                      v-for="Level in LevelName"
                      v-bind:key="Level.serial"
                      :value="Level.serial"
                      >{{ Level.StageName }}
                      </b-form-select-option>
                  </b-form-select>
                </div>

                <hr />
                <div>
                  <h6>Specialization</h6>
                  <span class="col-md-2">Student Specialization</span>
                  <b-form-select v-b-tooltip.hover title="Student Specialization"
                    v-model="Specializationinsert"
                    class="mb-3 col-md-8"
                  >
                    <!-- <b-form-select-option :value="null">Please select an option</b-form-select-option> -->
                    <b-form-select-option
                      v-for="spac in Specialization"
                      v-bind:key="spac.SpecializationID"
                      :value="spac.SpecializationID"
                      >{{ spac.SpecializationNameEN }}</b-form-select-option
                    >
                  </b-form-select>
                </div>

                <hr />
                <div>
                  <h6>Courses</h6>
                  <b-row>
                    <b-col class="col-md-6 mt-1">Course Code</b-col>
                    <b-form-input v-b-tooltip.hover title="Course Code"
                      v-model="courseCode"
                      class="col-md-6"
                      placeholder="Enter course code"
                    ></b-form-input>
                    <b-col class="col-md-6 mt-1">Course Name</b-col>
                    <b-form-input v-b-tooltip.hover title="Course Name"
                      v-model="courseName"
                      class="col-md-6"
                      placeholder="Enter course Name"
                    ></b-form-input>
                  </b-row>
                </div>
              </div>
            </div>
          </div>
          <div class="text-center col-md-3 float-right">
            <b-button
              class="mt-3  btn-success"
              block
              @click="$bvModal.hide('modal-lg'), filteredCourses2()"
              >Search</b-button
            >
          </div>
        </b-modal>
        <!-- End Filter -->

      </div>
    </h1>

    <div class="row">
      <b-col sm="12" md="2" class="border-right">
        <!-- <b-alert show variant="dark">
      <div class="text-center"><h1> Current CGPA <br/><span class="text-success">12345</span></h1></div>
    
      <div class="row">
        <div class="col-md-6 text-center"><h6>Resulted GPA<br/><span class="text-success">12345</span></h6></div>
         <div class="col-md-6 text-center"><h6>Resulted CGPA<br/><span class="text-success">12345</span></h6></div>
      </div>

     </b-alert> -->

        <div class="iconCart">
          <img src="../../assets/pngwave.png" width="50px" />
          <div class="cart">{{ cardItemsCount.length }}</div>
        </div>
        <ul>
          <li v-for="(course, index) in cardItemsCount"
            :key="index" :id="course.CourseName"
            class="menu">

            {{ course.CourseName }}
            <!-- id for course name target for course name  -->
            <b-popover v-bind:target="course.CourseName" triggers="hover" placement="right"  >
              <template #title variant="primary"> Cart 
                <span class="text-right float-right">
                  <b-icon icon="pencil-square" variant="success"  v-b-modal.modal-center  class="text-right  mr-2" v-b-tooltip.hover title="Edit Subject" @click="GetCourseSections(course.CourseID)" v-show="!disableSingleRegister"> </b-icon>
                  <b-icon icon="trash"  variant="danger" class="text-right" v-b-tooltip.hover title="Delete Subject" @click="RemoveCartItem(course.CourseID)" :disabled="disableSingleRegister" v-show="!disableSingleRegister"> </b-icon>
                </span>
              </template>
              <h6 class="h6">{{ course.CourseName }}</h6>
              <div class="line" v-for="(courseSec,index) in course.SectionsList" :key="index">
                <b-icon icon="building" variant="primary"></b-icon>
               {{courseSec.TypeNameEN}}
                <span
                  class="float-right bg-primary p-2 text-white text-center rounded "> H :  {{course.CreditHours}} 
                  <div class="line"></div>
                     S : {{courseSec.SectionNumber ?courseSec.SectionNumber : '' }} 
                  </span
                > 
                <div class="line h6">
                <b-icon icon="clock-fill" variant="primary"></b-icon> 
                  {{courseSec.Schedule }}
              </div>
              </div>
             


              <!-- <div class="line">
                <b-icon icon="house" variant="primary"></b-icon> LAB
              </div>
              <div class="line">
                <b-icon icon="filter" variant="primary"></b-icon> {{course.Sections[1].SectionNumber ? course.Sections[1].SectionNumber : ''}} 
              </div>

              <div class="line h6">
                <b-icon icon="clock-fill" variant="primary"></b-icon> 
                {{course.Sections[1].Schedule }} 
              </div> -->
              <div class="text-right mt-3">
                <b-button variant="success" @click="RegisterOneCourse(course.CourseID)" :disabled="disableSingleRegister"> Register </b-button>
              </div>
            </b-popover>
          </li>

          <!-- <li class="menu">Course Name</li>
     <li class="menu">Course Name</li>
     <li class="menu">Course Name</li> -->
        </ul>
        <div class="text-center mt-3 mb-3">
          <b-button variant="success" @click="RegisterAll()" :disabled="cardItemsCount.length == 0 || disableSingleRegister " > Register All</b-button>
        </div>
       
      </b-col>
      <b-col sm="12" md="10">
        <div class="text-center" v-if="isLoading ">
          <b-spinner variant="primary" label="Text Centered"></b-spinner>
        </div>
 <div class="alert alert-success"><div class="float-left">Total Credit Hours : <span class="bg-success p-2 white-text rounded mr-4"> {{AllHours.AvailableCredits}}</span> </div><div> Total Registered Credits : <span class="bg-success p-2 white-text rounded mr-4">{{AllHours.RegisteredCredits}}  </span></div></div> 
        <b-card-group deck>
          <!-- <b-card header="PHG 1101" class="col-md-4 col-sm-12 select" border-variant="primary" sm="12" :class="{ active2 : deleteClicked }">
        <b-card-text>Bontany & Medicinal Plants <br/>Credit Hours3  </b-card-text>
         <div class="text-center"><b-button v-b-modal.modal-center class="subButton" @click="GetCourseSections">Add</b-button></div>

        
      
      </b-card>  -->
      
            <div v-if="message" class="alert alert-danger col-12" role="alert" v-html="message.split('/').join('<br>')"></div>
          <!-- Start Dynamic Cards -->
          <div class="row" v-if="!isLoading">

                  <b-card  class="col-md-12 col-sm-12 select mb-5" border-variant="primary" sm="12"  v-if="empty">
                       No data found , Please try again using different options.
                  </b-card>

            <!-- <b-card v-else
              v-for="(subject, index) in selectSubjectList"
              :value="subject.serial"
              v-bind:key="index"
              :header="subject.CourseCode"
               :header-bg-variant="subject.isRegistered === true ? 'bg-light-green' : 'warning'"
  header-text-variant="white"
              class="col-md-4 col-sm-12"
              
              border-variant="primary"
              v-bind:class="[checkFound(subject.serial) ? 'bg-success' : '', getCardClass(subject.CourseStateID) ]"
            >
              <b-card-text>
                {{ subject.CourseNameEN }} <br />
                CreditHours : {{ subject.CreditHours }}
              </b-card-text>

              <div class="text-center">
                <b-button
                  v-b-modal.modal-center
                  class="subButton"
                  @click="GetCourseSections(subject.serial)"
                  >Add</b-button
                >
              </div>
            </b-card> -->
          
        <b-card v-else
  v-for="(subject, index) in selectSubjectList"
  :value="subject.serial"
  :key="index"
  :header="subject.CourseCode"
  :header-bg-variant="subject.isRegistered == true ? 'success' : ''" 
  
  class="col-md-4 col-sm-12"
  border-variant="primary"
  :class="[ checkFound(subject.serial) ? 'bg-success' : '', getCardClass(subject.CourseStateID) ]"
>
  <b-card-text>
    {{ subject.CourseNameEN }} <br />
    CreditHours : {{ subject.CreditHours }}
  </b-card-text>

  <div class="text-center">
    <b-button
      v-b-modal.modal-center
      class="subButton"
      @click="GetCourseSections(subject.serial)"
    >
      Add
    </b-button>
  </div>
</b-card>
  
          </div>

          <!-- End Dynamic Cards -->
        </b-card-group>
      </b-col>
      <!-- modal start -->

      <b-modal
        id="modal-center"
        size="lg"
        centered
        :title="courseSection.length > 0 ? courseSection[0].SectionsList[0].CourseName : ''"
        cancel-only
      >
        <!-- <loader v-if="isSectionLoading" object="#ff9633" color1="#ffffff" color2="#17fd3d" size="5" speed="2" bg="#343a40" 
              objectbg="#999793" opacity="80" name="circular"></loader> -->
        <div class="text-center" v-if="isSectionLoading">
          <b-spinner variant="primary" label="Text Centered"></b-spinner>
        </div>

        <b-row>
          <b-col
            cols="12"
            md="4"
            class="border-right"
            v-for="(lec, index) in courseSection"
            v-bind:key="index"
          >
            <b-button variant="primary">{{ lec.TypeNameEN }}</b-button>

            <div class="responsive w-100" >            
              
              <div
                v-for="item in lec.SectionsList"
                v-bind:Key="item.TypeNameEN"
              >
                <table
                  class="table table-hover bordered  w-100 table-bordered table-striped mb-2 font-weight-bold h3"
                >
                  <tr>
                    <th>Select</th>
                    <th>Section Number</th>
                    <th>Available Seats</th>
                    
<th>
  <p 
    :class="item.IsConflict == false ? 'bg-success text-white p-2 rounded d-flex align-items-center' : 'bg-danger text-white p-2 rounded d-flex align-items-center'"
  >
    <b-icon 
      :icon="item.IsConflict == false ? 'check-circle-fill' : 'x-circle-fill'" 
      class="mr-2"
    ></b-icon>
    {{ item.IsConflict == false ? 'Available' : 'Conflict' }}
  </p>
</th>


                  </tr>

                  <!--   -->
                  <tbody>
                    <tr>
                      <td>
                        <input
                          type="radio"
                          :name="item.TypeNameEN"
                          :value="item.CourseSectionID"
                          :checked="item.IsSelected == true"
                          v-model="choosed[`${item.TypeNameEN}`]"
                        />
                      </td>
                      <td>{{ item.SectionNumber }}</td>
                      <td>{{ item.AvailableSeats }}</td>
                      <!-- <td> <div v-for="(prof,index) of item.ProfessorLst" :key="index"> {{ prof.Name }} </div></td> -->
                      <td colspan="4" class="table-success">
                        <div  v-for="(schedule, index) in item.ScheduleLst" :key="index">
                        <span variant="success">
                          <strong> Day:</strong> {{ schedule.WeekDay }} 
                          From {{ schedule.StartTime }} to {{ schedule.EndTime }}
                          <!-- <strong> Number:</strong> {{ item.RoomName }} -->
                          </span>
                          <br>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <!--  
 <template>
     
    
        <b-button @click="InsertSubjectToCard(item.TypeNameEN); ok();" size="sm" variant="success">
      Add To Cart
    </b-button>
      <b-button size="sm" variant="danger" @click="cancel()">
        Back
      </b-button>
    
    </template> -->
              </div>
            </div>
          </b-col>
        </b-row>

        <template #modal-footer="{ ok, cancel,}">
          <b-button
            @click="
              InsertSubjectToCard();
              ok();
            "
            size="sm"
            variant="success"
            
          >
            Add To Cart
          </b-button>
          <b-button size="sm" variant="danger" @click="cancel()">
            Back
          </b-button>
        </template>
      </b-modal>
    </div>
  </div>
</template>
<script>
import SelectSubject from "../../services/academic/SelectSubject.services";
//import ApplicantService from '../../services/Applicant/Applicant.service';
// Vue.use(axios)  
import Vue from 'vue'
import VueSimpleAlert from "vue-simple-alert";
Vue.use(VueSimpleAlert)
import StudentAdvisorServices from '../../services/academic/StudentAdvicessServices'
import Help from '../Help.vue'
import {Course} from '../../models/academic/Course'
export default {
  name: "SelectSubject",
  components:{
    Help
  },
  data() {
    return {
      empty : true, 
     
      deleteClicked: false,
      selectSubjectList: [],
      courseSection: [],
      isLoading: true,
      isSectionLoading: true ,
      LCTR: [],
      LCLB: {},
      LCTU: {},
      text: "",
      change: false,
      selected2: null,
      selected: null,
      options: [
        { value: null, text: "Please select an option" },
        { value: "A", text: "This is First option" },
        { value: "B", text: "This is scond option" },
        { value: "C", text: "This is third option" },
      ],
      addLCTRandLCLB: [],
      selectedSection: [],
      cardItemsCount: [],
      isRegistered : false,

      FilterCourses:'',
      LevelNameinsert:'0',
       LevelName:'',
       Courses:[],
           Specialization:'',
       Specializationinsert:'0',
        courseCode:'',
        courseName:'',
        message:'',
        choosed:{
        },
        allowUpdateDrop:false,
        disableSingleRegister : false
    };
  },
  computed: {
    currenUser() {
      return this.$store.state.auth.user;
    },
        StudentStatus(){
          this.$store.dispatch('Advisor/AdvisorStatus',this.currenUser.StudentID)

        return this.$store.state.Advisor
    },
   
    
  },

  async created(){
      // this.$store.dispatch('Advisor/AdvisorStatus',this.currenUser.StudentID)
     await SelectSubject.GetFacultyLevels(this.currenUser.FacultyID_Enrollment).then(Response =>{
               
               this.LevelName = Response.data
                this.empty =false
                // console.log('levels name: ', this.LevelName)
           }, error => {
      
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            }) 
       
    await  SelectSubject.GetFacultySpecializations(this.currenUser.FacultyID_Enrollment).then(Response =>{
             
               this.Specialization = Response.data
                this.empty =false
            
           }, error => {
              
                  // eslint-disable-next-line no-console
                  // console.log(error.response.status)
                 
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            }) ,

            await  SelectSubject.GetRegistrationCredits(this.currenUser.StudentID, 3).then(Response =>{
             
               this.AllHours = Response.data
                this.empty =false
            
           }, error => {
              
                  // eslint-disable-next-line no-console
                  // console.log(error.response.status)
                 
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            }) 
            

  },

  async mounted() {

    const firstLec = this.courseSection.find(l => l.TypeNameEN === 'LCTR');
  if (firstLec && firstLec.SectionsList.length > 0) {
    const firstItem = firstLec.SectionsList[0];
    this.choosed[firstItem.TypeNameEN] = firstItem.CourseSectionID;
  }
    
    //  let id = 11;

    // ApplicantService.GetHelpPages(id).then(response => {
    //     this.info = response.data
    //   });
    
     await   this.GetRegistrationPeriodSelect()
    //  await   this.GetRegistrationCredits()

    
    await this.getAllStudentCartItemsCount();


   await this.getAllStudentRegistrationCourses();
 
  
    

    //this.getAllCartItemsCount();
  },

  methods: {
   
   async getAllStudentRegistrationCourses() {
      // 22, 0, 0, 0, 'p', 'p', 3
      this.isLoading =true
     await SelectSubject.GetStudentRegistrationCourses(this.currenUser.StudentID, this.currenUser.FacultyID_Enrollment,
                             0, 0, "", "", 3 ).then( (Response) => {
        
          this.selectSubjectList = Response.data;
          if(this.selectSubjectList.length == 0) {
            this.isLoading = false;
          this.empty = true}else{
            this.empty =false
         this.selectSubjectList =  this.selectSubjectList.map(item => {
            return new Course(item.CourseCode,item.CourseNameEN,
          item.CourseStateID,item.CreditHours,item.Description,item.serial,item.isRegistered )
          }) 
            this.isLoading = false;
          }
          // eslint-disable-next-line no-console
          // console.log("Select Subject ", Response.data);
        },
        (error) => {
          // eslint-disable-next-line no-console
          // console.log(error.response.status);
          this.isLoading = false ;
          this.message =
            (error.response &&
              error.response.data &&
              error.response.data.Message) ||
            error.message ||
            error.toString();

          if (error.response.status == 404) this.message = "";
        }
      );
    },

    async GetCourseSections(serial) {
      // 6, 22, 3583
      // this.isLoading = false;
      this.isSectionLoading = true;
      this.courseSection = [];
      this.selectedSection = serial;
      await SelectSubject.GetAllCourseSections( serial, this.currenUser.StudentID, this.currenUser.EnrollmentID).then( (Response) => {
         
          this.courseSection = Response.data;
          this.LCTR = this.courseSection.map((item) => item.TypeNameEN);
          this.LCTR = [...new Set(this.LCTR)];
    
              this.LCTR.forEach(element => {
              
                  this.choosed[element] = this.courseSection.filter(y=>y.TypeNameEN == element)[0].SectionsList.filter(y=>y.IsSelected == true) !=0 ? this.courseSection.filter(y=>y.TypeNameEN == element)[0].SectionsList.filter(y=>y.IsSelected == true)[0].CourseSectionID : ''
                  });

           this.isSectionLoading = false;               
        },
        (error) => {
          // eslint-disable-next-line no-console
          // console.log(error.response.status);
          
          this.message =
            (error.response &&
              error.response.data &&
              error.response.data.Message) ||
            error.message ||
            error.toString();

          if (error.response.status == 404) this.message = "";
        }
      );
    },

  filteredCourses2(){

        //this.IsSelected = false;
          this.isLoading = true;

        //   if(this.FilterCourses === "All") { 

        //  //this.IsSelected = false;
        //   } else 
        //   {
        // // this.IsSelected = true;
        //   }

             SelectSubject.GetStudentRegistrationCourses(this.currenUser.StudentID, this.currenUser.FacultyID_Enrollment,
                             this.Specializationinsert, this.LevelNameinsert, this.courseCode, this.courseName, 3 ).then( (Response) => {
           this.isLoading = false ;
               this.selectSubjectList = Response.data
               this.selectSubjectList =  this.selectSubjectList.map(item => {
            return new Course(item.CourseCode,item.CourseNameEN,
          item.CourseStateID,item.CreditHours,item.Description,item.serial,item.isRegistered)
          }) 
                this.empty =false
                 
              if(this.selectSubjectList == 0)
              {
                this.empty = true;
                return true;
              }
                          
                  // console.log('Courses => ', this.Courses);
                  // console.log('this.levels => ', this.levels);
           }, error => {
            this.isLoading = false ;
            this.empty =true
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            }) 
        this.courseCode='';
        this.courseName='';
        this.LevelNameinsert='0';
        this.IsSelected = false;
        this.Specializationinsert='0';

        }, 
 async getAllStudentCartItemsCount() {
    //this.isLoading = true
    await  SelectSubject.StudentCartItems(this.currenUser.StudentID, 3).then(
        (Response) => {
          //this.isLoading = false;
          this.cardItemsCount = Response.data.CoursesList;
          // let Courses=  this.cardItemsCount.map(item=> item.CourseNameEN)
          this.cardItemsCount = [...new Set(Response.data.CoursesList)];
          // console.log("StudentCartItems => ", this.cardItemsCount);
          this.message = Response.data.ErrorMessage ? Response.data.ErrorMessage : ''
        },
        (error) => {
         // this.isLoading=false
          this.message = (error.response && error.response.data && error.response.data.Message) ||
            error.message || error.toString();

          if (error.response.status == 404) this.message = "";
            this.cardItemsCount = []
        }
      );
    },

   async InsertSubjectToCard() {

      let check= false
       Object.keys(this.choosed).filter((k)=> {
          if (this.choosed[k] === "" || this.choosed[k]===undefined || this.choosed[k]===null) {
            
            this.$fire({
                  title: "Warning",
                  text: `${k} is not selected`,
                  type: "warning",          
                })
                return check = true
          }
        });
       if(check == true){
        return true
       }else{
        let used = []
        let newobj = {}
        let item
        Object.values(this.choosed).forEach((element,i)=>{
          //console.log(element + i)
           item = this.courseSection.filter(y=>y.TypeNameEN == Object.keys(this.choosed)[i])[0].SectionsList.filter(y=>y.CourseSectionID == element)[0].StudentAllowedSerial
          console.log('item',item)
          newobj.CourseSectionID = element
          newobj.StudentAllowedSerial = item
          newobj.index = i
          let newObj = Object.assign({},newobj );
          used.push(newObj)
          
        })

       await this.addToCart(used)
       }
      
    },
    onClick() {
      this.deleteClicked = true;
    },
    ok() {
      this.change = true;
    },
    addToCart(section) {
      this.disableSingleRegister = true
      console.log("sectioooooon", section);
      SelectSubject.AddToCart( this.currenUser.StudentID,this.selectedSection, section,3).then((Response) => {
          this.addLCTRandLCLB = Response.data;
          this.empty = false;

          // eslint-disable-next-line no-console
          //  console.log("addLCTRandLCLB => ", this.addLCTRandLCLB);
          // this.$alert(this.addLCTRandLCLB);
           this.$fire({
            title: "Add Subject",
            text: this.addLCTRandLCLB,
            type: "success",
            timer: 3000
          });
         // window.location.reload();
         this.getAllStudentCartItemsCount();
         this.disableSingleRegister = false
        },
        (error) => {
         
          
          this.message = (error.response && error.response.data && error.response.data.Message) ||
            error.message || error.toString();

            
            if (error.response.status == 404) this.message = "";
            if (error.response.status == 500) this.message = error.response.data.ExceptionMessage ? error.response.data.ExceptionMessage :error.response.data.Message ;
            this.$fire({
                 title: "Error",
                 html: this.message.split('/').join('<br>'),
                 type: "error",
                 timer: 5000
              })
              this.disableSingleRegister = false
        }
      );
    },

   async RemoveCartItem(CourseID){
      this.disableSingleRegister = true
      this.cardItemsCount.filter(x=>x.CourseID != CourseID)
     let confirm =  window.confirm('Are You sure you want to delete this course')
     if(confirm){
    await  SelectSubject.CheckRegisteredCoRequisite(this.currenUser.StudentID, CourseID).then(res=>{
        console.log(res.data)
        SelectSubject.RemoveCartItem(this.currenUser.StudentID, CourseID, 3).then( (Response) => {
         // this.isLoading = false;
        // console.log("remove cart item  => ", Response.data);                 
               //this.$alert(Response.data);
              this.$fire({
                title: "Delete",
                text: Response.data,
                type: "info",
                timer: 3000
             })
         this.getAllStudentCartItemsCount();
         this.disableSingleRegister = false
        },
        (error) => {          
          this.message = (error.response && error.response.data && error.response.data.Message) ||
            error.message || error.toString();

          if (error.response.status == 404) this.message = "";
           this.$fire({
                title: "Error",
                text: this.message,
                type: "error",
                timer: 5000
             })
             this.disableSingleRegister = false
        }
      )
      },errorMessage=>{
        let confirm = window.confirm(errorMessage.response.data.Message)
        if (confirm){
          SelectSubject.RemoveCartItem(this.currenUser.StudentID, CourseID, 3).then( (Response) => {
         // this.isLoading = false;
        // console.log("remove cart item  => ", Response.data);                 
               //this.$alert(Response.data);
              this.$fire({
                title: "Delete",
                text: Response.data,
                type: "info",
                timer: 3000
             })
         this.getAllStudentCartItemsCount();
         this.disableSingleRegister = false
        },
        (error) => {          
          this.message = (error.response && error.response.data && error.response.data.Message) ||
            error.message || error.toString();

          if (error.response.status == 404) this.message = "";
           this.$fire({
                title: "Error",
                text: this.message,
                type: "error",
                timer: 5000
             })
        }
      )
        }
      })
     }
      
   
   }, 

    async RegisterOneCourse(CourseID){
      //console.log('RegisterOneCourse CourseID', CourseID);
      this.disableSingleRegister = true
     await SelectSubject.RegisterOneCourse(this.currenUser.StudentID, CourseID, 3).then( (Response) => {
         // this.isLoading = false;
          //console.log("RegisterOneCourse  => ", Response.data);
          //this.$alert(Response.data);
          this.$fire({
              title: "Register Course",
              text: Response.data,
              type: "success",
              timer: 3000
          })
          this.getAllStudentCartItemsCount();
          this.disableSingleRegister = false
             setTimeout(() => {
        window.location.reload()
      }, 3100) // reload after the alert finishes
        },
        (error) => {          
          this.message =
            (error.response &&
              error.response.data &&
              error.response.data.Message) ||
            error.message ||
            error.toString();

          if (error.response.status == 404) this.message = "";
         // this.$alert(this.message);
           this.$fire({
                title: "Error",
                html: this.message.split('/').join('<br>'),
                type: "error"
             })
             this.disableSingleRegister = false
        }
      )
   
    }, 

   async RegisterAll(){
    this.disableSingleRegister = true
    await  SelectSubject.RegisterAll(this.currenUser.StudentID, 3).then( (Response) => {
          //this.isLoading = false;
         this.$fire({
              title: "Register All",
              text: Response.data,
              type: "success",
              timer: 3000
          })
         this.getAllStudentCartItemsCount();
         this.disableSingleRegister = false
           // Reload page after success
      setTimeout(() => {
        window.location.reload()
      }, 3100) // reload after the alert finishes
        },
        
        (error) => {          
          this.message = (error.response && error.response.data && error.response.data.Message) ||
            error.message || error.toString();
//            this.$alert();
          if (error.response.status == 404) this.message = "";
           this.$fire({
                title: "Error",
                 html: this.message.split('/').join('<br>'),
                type: "error",
                timer: 5000
             })
             this.disableSingleRegister = false
        }
      )
   
    },

    GetStudentAdvisorCourses(){
       StudentAdvisorServices.Student_Allowed_Forbidden_Courses_get(this.currenUser.StudentID).then((Response) => {
        
         
          this.selectSubjectList = Response.data.filter(x=> x.IsApproved == true);
          this.selectSubjectList = this.selectSubjectList.map(item => {
            return new Course(item.CourseCode,item.CourseName,
          item.CourseStateID,item.CreditHours,item.Description,item.Serial)
          }) 
            this.isLoading = false;
          // eslint-disable-next-line no-console
          
        },
        (error) => {
          // eslint-disable-next-line no-console
          // console.log(error.response.status);
          this.isLoading = false ;
          this.message =
            (error.response &&
              error.response.data &&
              error.response.data.Message) ||
            error.message ||
            error.toString();

          if (error.response.status == 404) this.message = "";
        }
      );
   },
   async  GetRegistrationPeriodSelect(){
   await SelectSubject.GetRegistrationPeriodSelect().then(res=>{
              //console.log(res.data)
              this.allowUpdateDrop = res.data[0].IsActive
              if(this.allowUpdateDrop == false){
                this.$router.push('/RegistrationHome')
              } 
            })
           },
           async StudentCustomRegistrationCourses(){
            this.isLoading = true
           await SelectSubject.StudentCustomRegistrationCourses(this.currenUser.StudentID,3).then(res=>{
              this.isLoading = false ;
               this.selectSubjectList = res.data
               this.selectSubjectList =  this.selectSubjectList.map(item => {
            return new Course(item.CourseCode,item.CourseNameEN,
          item.CourseStateID,item.CreditHours,item.Description,item.serial)
          }) 
                this.empty =false
                 
              if(this.selectSubjectList == 0)
              {
                this.empty = true;
                return true;
              }
            })
           },
           checkFound(CourseId){
      
      return this.cardItemsCount.some(x=>x.CourseID == CourseId)
    },
     getCardClass(courseStateId) {
      return courseStateId === 1 ? 'bg-warning' : '';
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

.help {
  color: #fff;
  background-color: #ff8600;
  /* padding: 2px 16px; */
}

.panal {
  background: #fff;
  border-radius: 10px;
  color: #fff;
  padding: 0px 0px 20px 0px;
  margin: 10px 0;
  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  margin-bottom: 20px !important;
}
.panal-header {
  background: #285475;
  color: #ffffff;
  text-align: left;
  border-radius: 10px 0px 0px 0px;
  padding: 10px 20px;
  font-size: 17px;
  font-weight: bold;
  width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body {
  padding: 20px;
  color: #333;
}
.modal-lg {
  min-width: 90vw;
}
.active2 {
  color: #fff !important;

  background-color: #007bff !important;
}
.active2 .subButton,
.active2 button {
  background-color: #28a745 !important;
}

h1 {
  color: #285475;
  font-size: 25px;
  border-bottom: 1px #646464 dashed;
  padding: 10px 0px;
}
h1 a {
  color: #ff8600;
}
.border-right {
  border-right: 1px solid #dee2e6 !important;
}
.iconCart {
  width: 60px;
  height: 70px;
  margin: 0 auto;
  position: relative;
  padding-top: 15px;
}
.iconCart .cart {
  position: absolute;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: #50bd77 dotted 1px;
  top: 0px;
  background: #fff;
  right: 20px;
  text-align: center;
  color: #50bd77;
  font-size: 18px;
}
ul {
  padding-left: 0px;
}
li.menu {
  border-bottom: 1px #646464 dashed;
  color: #285475;
  font-size: 17px;
  list-style: none;
  padding: 10px 0px;
}

.card-deck .card {
  -webkit-box-flex: 1;
  flex: 1 0 25%;

  margin-bottom: 20px;
  padding: 0;
}
.subButton {
  margin-bottom: -50px;
  width: 50%;
  background: #285476;
  text-align: center;
  border: 0px;
}
th,
td {
  font-size: 0.7rem !important;
}

.popover.b-popover {
  width: 300px;
}

.line {
  border-bottom: 1px #646464 dashed;
  padding: 5px 0px;
}
.row{
  width  :100%
}
.light2 {
  background-color: #d4f7d4 !important; /* light green */
}
@media screen and (max-width : 600px) {
  .float-right>button.btn-secondary[title = 'Filter'] {
    margin-top: 15px;
  }
  .card-deck .card {
 
  flex: 1 0 100%;

  
}
}
</style>
